import Footer from "./components/SiteFooter";
import ScrollToTop from "./components/ScrollToTop";

export default function SiteShell({ children }) {
  return (
    <div className="site-theme flex min-h-screen flex-col bg-white text-[#2b2f38]">
      <ScrollToTop />
      <div className="flex-1 pt-28">{children}</div>
      <Footer />
    </div>
  );
}
